import { ApplyMiddlewares } from '@middlewares';
import { Flag } from '@utils';
import { Permission } from '@common/utils/admin_permissions';
import { ReactElement } from 'react';

interface AdminLayoutWrapProps {
  children: ReactElement;
  flag?: Flag;
  permissions?: Permission[];
}

export function adminLayoutWrap({ children, flag, permissions }: AdminLayoutWrapProps) {
  return (
    <ApplyMiddlewares flag={flag} permissions={permissions}>
      {children}
    </ApplyMiddlewares>
  );
}
